import { render, staticRenderFns } from "./Pusher.vue?vue&type=template&id=487c2653&"
import script from "./Pusher.vue?vue&type=script&lang=js&"
export * from "./Pusher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports